
import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import AdminCheckWrapper from '@/components/analytics/admin/AdminCheckWrapper';
import AdminContentDashboard from '@/components/admin/content/AdminContentDashboard';

const AdminContent = () => {
  return (
    <AdminCheckWrapper>
      {(isAdmin) => (
        <div className="min-h-screen flex flex-col bg-background">
          <Navbar />
          
          <main className="flex-1 py-16 px-4 max-w-[1440px] mx-auto w-full">
            <AdminContentDashboard isAdmin={isAdmin} />
          </main>
          
          <Footer />
        </div>
      )}
    </AdminCheckWrapper>
  );
};

export default AdminContent;
